import { Helmet } from "react-helmet-async";
import { Navigate, useParams } from "react-router-dom";
import { FUNNELS } from "../data/funnelContent";
import { AUDIENCES } from "../data/personaContent";
import { SalesTriadSection } from "../components/common/SalesTriadSection";
import { OrderNowBottomCTA } from "../components/common/ServiceOrderBundle";
import { PersonaHeader, PersonaHero, StepsBlock, FaqBlock } from "../components/persona/PersonaSections";
import { AllInOffer } from "../components/persona/AllInOffer";

const CSS = `
@keyframes personaUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: none; } }
.persona-reveal { animation: personaUp .7s cubic-bezier(.2,.7,.2,1) both; }
.persona-delay-1 { animation-delay: .15s; }
`;

const ALLIN_FAQ = [
  { q: "Čo znamená cena zamknutá navždy?", a: "Ak si mesačný plán objednáte do 31. 12. 2026, platíte €79 mesačne aj po skončení ponuky, kým predplatné nezrušíte." },
  { q: "Ako funguje platba do konca roka?", a: "Zaplatíte €590 jednorazovo a všetky nástroje máte do 31. 12. 2026. Nič sa automaticky neobnovuje." },
  ...AUDIENCES.firmy.faq,
];

export const ALLIN_GENERAL = {
  badge: "Špeciálna ponuka do 31. 12. 2026",
  headline: "Všetky nástroje TopRankPulse",
  highlight: "za €79 mesačne.",
  sub: "AI audity, sledovanie AI vyhľadávačov, konkurencie, bezpečnosti webu, autopilot úprav a AI články. Jeden plán, jedna cena, zamknutá navždy.",
  images: FUNNELS[7].images,
  triad: FUNNELS[7].triad,
};

export function FunnelPage({ funnel, testid }) {
  const page = { ...funnel, image: funnel.images.square };
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white" data-testid={testid}>
      <Helmet>
        <title>{`${funnel.headline} ${funnel.highlight} | TopRankPulse`}</title>
        <meta name="description" content={funnel.sub} />
        <meta property="og:title" content={`${funnel.headline} ${funnel.highlight}`} />
        <meta property="og:description" content={funnel.sub} />
        <meta property="og:image" content={funnel.images.google} />
      </Helmet>
      <style>{CSS}</style>
      <PersonaHeader />
      <PersonaHero page={page} isAgency={false} />
      <SalesTriadSection {...funnel.triad} />
      <StepsBlock steps={AUDIENCES.firmy.steps} />
      <AllInOffer />
      <FaqBlock faq={ALLIN_FAQ} />
      <div className="max-w-5xl mx-auto px-5 sm:px-8 pb-16">
        <OrderNowBottomCTA packageId="allin_2026_monthly" priceEur={79} interval="mes" serviceName="Všetko v jednom 2026"
          headline="Zamknite si cenu €79 navždy" subcopy="Ponuka platí do 31. 12. 2026. Zrušiteľné kedykoľvek jedným klikom." testid="funnel-final-cta" />
      </div>
    </div>
  );
}

export default function FunnelLandingPage() {
  const { slug } = useParams();
  const funnel = FUNNELS.find((f) => f.slug === slug);
  if (!funnel) return <Navigate to="/vsetko-v-jednom-2026" replace />;
  return <FunnelPage funnel={funnel} testid={`funnel-page-${slug}`} />;
}

export function AllInOfferPage() {
  return <FunnelPage funnel={ALLIN_GENERAL} testid="allin-offer-page" />;
}
